export default {
  namespaced: true,
  state: {
    devices: [],
  },
  getters: {
    devices: state => state.devices,
    devicesList: state => state.devices.map(device => ({
      id: device.id,
      name: device.name,
      sno: device.sno,
    })),
    devicesCount: state => state.devices.length,
  },
  actions: {
    // none yet
  },
  mutations: {
    setDevices(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.devices = data;
    },
    clearDevices(state) {
      // eslint-disable-next-line no-param-reassign
      state.devices = [];
    },
  },
};
